import {SEND_A} from 'constants/midi-cc-actions.js';
import {getVolume, getGainVolume} from 'utils/getVolume.js';

class MidiKnobAction {
    constructor(action) {
        this.action = action;
    }

    onChange(track, value) {
        if (this.action === SEND_A && track) {
            track.setSendVolume(0, getVolume(value, 0, 128));
        }
    }
}

export default MidiKnobAction;
